import { RepositoriesService } from 'app/API';
import { cancelOnSignal } from 'app/API/core/CancelablePromise';
import type { QueryFunctionContext } from '@tanstack/react-query';
import type { TCall, TCallOptions } from 'app/queries/types/TCall';
import type { repositoriesKeys } from './repositoriesKeys';

type TParams = QueryFunctionContext<ReturnType<typeof repositoriesKeys.audioAttachmentsByRepository>>;

export const createFetchRepositoryAudioAttachmentsQueryFn =
  (call: TCall, options?: TCallOptions) =>
  ({ queryKey: [{ repositoryId }], signal }: TParams) =>
    call(() => cancelOnSignal(RepositoriesService.findAllAudioAttachments({ repositoryId }), signal), options);
